import { useState } from "react";
import axios from "axios";
import { API } from "@/contexts/AuthContext";
import { Lightbulb, X } from "lucide-react";

const STORAGE_KEY = "tuto_suggestion_done";

export default function FeatureSuggestionBanner() {
  const [visible, setVisible] = useState(() => !localStorage.getItem(STORAGE_KEY));
  const [modalOpen, setModalOpen] = useState(false);
  const [texto, setTexto] = useState("");
  const [pagaria, setPagaria] = useState(null);
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  if (!visible) return null;

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, "1");
    setVisible(false);
    setModalOpen(false);
  };

  const handleSubmit = async () => {
    if (!texto.trim()) return;
    setLoading(true);
    try {
      await axios.post(`${API}/feedback/sugestao`, { texto, pagaria_97: pagaria }, { withCredentials: true });
      setSent(true);
      setTimeout(dismiss, 2000);
    } catch {
      // silencioso
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Banner */}
      <div className="w-full bg-gradient-to-r from-[#003882] to-[#0052b4] text-white text-sm px-4 py-2.5 flex items-center justify-center gap-3 flex-wrap">
        <Lightbulb size={16} className="text-amber-300 flex-shrink-0" />
        <span>
          <strong>O que você gostaria de ter no TUTO?</strong>{" "}
          Nos conta quais funcionalidades fariam diferença no seu dia a dia.
        </span>
        <button
          onClick={() => setModalOpen(true)}
          className="bg-white text-[#003882] font-semibold rounded-md px-3 py-1 text-xs hover:bg-blue-50 transition-colors"
        >
          Sugerir funcionalidade
        </button>
        <button
          onClick={dismiss}
          className="text-white/60 hover:text-white transition-colors ml-1"
          aria-label="Fechar"
        >
          <X size={16} />
        </button>
      </div>

      {/* Modal */}
      {modalOpen && (
        <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg p-6 relative">
            <button
              onClick={() => setModalOpen(false)}
              className="absolute top-4 right-4 text-[#9bb0cc] hover:text-[#335480] transition-colors"
            >
              <X size={20} />
            </button>

            {sent ? (
              <div className="py-8 text-center">
                <div className="text-4xl mb-3">🙏</div>
                <p className="text-[#001533] font-semibold text-lg">Obrigado pela sugestão!</p>
                <p className="text-[#335480] text-sm mt-1">Sua opinião vai ajudar a moldar o futuro do TUTO.</p>
              </div>
            ) : (
              <>
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-10 h-10 rounded-xl bg-[#e5edf5] flex items-center justify-center">
                    <Lightbulb size={20} className="text-[#003882]" />
                  </div>
                  <div>
                    <h2 className="text-[#001533] font-bold text-base leading-tight">Sugerir funcionalidade</h2>
                    <p className="text-[#335480] text-xs mt-0.5">Sua opinião é essencial para evoluirmos o TUTO.</p>
                  </div>
                </div>

                <label className="block text-[#001533] text-sm font-medium mb-1.5">
                  Qual funcionalidade você gostaria de ter e por quê ela seria útil?
                </label>
                <textarea
                  value={texto}
                  onChange={(e) => setTexto(e.target.value)}
                  rows={5}
                  placeholder="Ex: Gostaria de poder exportar relatórios de intimações em PDF para enviar ao cliente..."
                  className="w-full border border-[#D1DEEE] rounded-xl px-4 py-3 text-sm text-[#001533] placeholder-[#9bb0cc] focus:outline-none focus:ring-2 focus:ring-[#003882]/30 focus:border-[#003882] resize-none"
                />

                <div className="mt-5">
                  <p className="text-[#001533] text-sm font-medium mb-3">
                    {/* preco-fixo: âncora da pesquisa de disposição a pagar, não é preço de plano */}
                    Se essa funcionalidade fosse lançada, você pagaria <strong>R$ 97,00</strong> por ela?
                  </p>
                  <div className="flex gap-3">
                    <button
                      onClick={() => setPagaria(true)}
                      className={`flex-1 py-2.5 rounded-xl border text-sm font-medium transition-all ${
                        pagaria === true
                          ? "bg-[#003882] border-[#003882] text-white"
                          : "border-[#D1DEEE] text-[#335480] hover:border-[#003882] hover:text-[#003882]"
                      }`}
                    >
                      Sim, pagaria
                    </button>
                    <button
                      onClick={() => setPagaria(false)}
                      className={`flex-1 py-2.5 rounded-xl border text-sm font-medium transition-all ${
                        pagaria === false
                          ? "bg-[#335480] border-[#335480] text-white"
                          : "border-[#D1DEEE] text-[#335480] hover:border-[#335480] hover:text-[#335480]"
                      }`}
                    >
                      Não, por enquanto não
                    </button>
                  </div>
                </div>

                <button
                  onClick={handleSubmit}
                  disabled={!texto.trim() || loading}
                  className="mt-5 w-full bg-[#003882] hover:bg-[#00306e] disabled:opacity-40 text-white font-semibold rounded-xl py-3 text-sm transition-colors"
                >
                  {loading ? "Enviando..." : "Enviar sugestão"}
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
